export default __webpack_public_path__ + "static/media/discord.dcbd531f.svg";